import { ErrorHandler, Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  handleError(error: any): void {
    const isChunkError =
      /Loading chunk \d+ failed/.test(error?.message) ||
      error?.message?.includes('ChunkLoadError') ||
      error?.message?.includes('Failed to fetch dynamically imported module');
    if (!isPlatformBrowser(this.platformId)) return;

    const isOffline = !navigator.onLine;

    if (isChunkError && !isOffline) {
      console.error('Chunk loading error detected:', error);

      const now = Date.now();
      const lastReloadTimestamp = Number(sessionStorage.getItem('chunk-reload-ts') || '0');
      const reloadCount = Number(sessionStorage.getItem('chunk-reload-count') || '0');

      const timeSinceLastReload = now - lastReloadTimestamp;
      const reloadCooldown = 10000; // 10 seconds
      const maxReloads = 5;

      if (reloadCount < maxReloads && timeSinceLastReload > reloadCooldown) {
        sessionStorage.setItem('chunk-reload-ts', now.toString());
        sessionStorage.setItem('chunk-reload-count', (reloadCount + 1).toString());
        window.location.reload();
      } else if (reloadCount >= maxReloads) {
        console.error(
          'Maximum reload attempts reached. Please manually refresh or try again later.'
        );
      } else {
        console.error('A chunk error occurred recently. Skipping reload to avoid a loop.');
      }
      return;
    }

    console.error('Global error:', error);
    // TODO: send error to monitoring service
  }
}
